export default "__VITE_ASSET__CpkR8Ics__"